import React, { useEffect } from 'react';
import { Button } from "@material-ui/core";
import { useState } from "react";
import { ButtonContain, ButtonContainO, ButtonOutline } from './material/Button';
import MaterialTable from 'material-table';
import { osName, browserName, browserVersion, } from 'react-device-detect';
import { ButtonBar } from './material/ButtonBar';
import { versionOld, checkOS, checkBrowser, WebSocketTest } from './WebSocketFunc';
import { StyleA,StyleRoot } from './style/StyledA';
import styled from "styled-components";
import CircularProgress from '@material-ui/core/CircularProgress';





// component --------------------------------------------------------------------------
const PassText = value => {
    if (value)
        return <span style={{ color: "green", }}>通過</span>
    else
        return <span style={{ color: "red", }}>未通過</span>
}

const App = (props) => {
  const { handleNext, handleBack, } = props;
  const [machine, setMachine] = useState(false);
  const [version, setVersion] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const checkWebSocketVersion = () => {     
      setIsLoading(true)
      const params = {}
      WebSocketTest("version",
          ws => () => { ws.send(JSON.stringify(params)); },
          ws => response => {
              const obj = JSON.parse(response.data);
              const version = obj.data.version;

              // 啟用失敗(未測到此情況)，或版本較舊，必須更新
              if (!obj.success || versionOld(version, osName)) {
                  setMachine(false)
              }
              // 啟用成功
              else { setMachine(true) }
              // 關閉元件？
              ws.close();

              setVersion(version)
              setIsLoading(false)
          },
          ws => error => {
              // IE 於 readyState === 2 必進 error，但並不是 error
              if (browserName === "IE" && ws.readyState === 2) { return }
              setVersion("")
              setMachine(false)
              setIsLoading(false)
          }
      )
  }

  useEffect(() => { checkWebSocketVersion() }, [])

  return (
    <div style={{
      backgroundColor: "rgb(247, 247, 247)", height: "100vh", minHeight: 500,
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>

  <StyleRoot>
      <div style={{ marginBottom: 10 , textAlign: "center" , fontSize: "40px"}}>
          ※簽章元件檢測※<br />       
      </div>
      <div style={{ marginBottom: 10 , textAlign: "left" , fontSize: "18px"}}>
          <div><StyleA href="https://ras.tradevan.com.tw/pras/Component/TVCrypto.exe" download style={{ color: "red" }}> 簽章元件下載</StyleA></div>  
      </div>
      <MaterialTable options={{
          toolbar: false, paging: false, sorting: false,
          headerStyle: { backgroundColor: "rgb(137, 134, 134)", color: "white", textAlign: "center", },
      }} columns={[
          { title: '檢查項目', field: 'item', cellStyle: { textAlign: "center", }, },
          { title: '檢查狀態', field: 'status', cellStyle: { textAlign: "center", }, },
          { title: '是否通過', field: 'pass', cellStyle: { textAlign: "center", }, },
      ]} data={[
          { item: '作業系統', status: osName, pass: PassText(checkOS(osName)), },
          { item: '瀏覽器', status: browserName+`，版本：${browserVersion}`, pass: PassText(checkBrowser(browserName, browserVersion)), },
          {
              item: '簽章憑證元件',
              status: <>{!version ? "未安裝或未啟動服務" : `元件版本：${version}`}
                  <ButtonOutline size="small" style={{ margin: "0 5px" }} onClick={() => checkWebSocketVersion()}>重新檢測</ButtonOutline>
              </>,
              pass: <>{machine
                ? PassText(true)
                : <a href="https://ras.tradevan.com.tw/pras/Component/TVCrypto.exe" download>請下載、安裝簽章憑證元件</a>
              }</>,
            },
          ]} />  
        {isLoading && <CircularProgress style={{color:'#4e8ab5',position:'absolute', left: '48%' , zIndex: '10' ,top: '50%',bottom: '0', width:'80px',height:'80px'}}/>}
  </StyleRoot>
  </div>
  );
}

export default App;
